export const SUPPORT_FRONTEND_PARAM_NAME = "-sf_p"
export const NP_MAX_LIMIT = 100000000;
export const SCAN_TYPE_MAX_LENGTH = 30;